import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Button from '@hfe/max-button';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import ScrollView from '@hfe/max-scrollview';
import Sensor from '@max/mbc-sensor';
import { PrizeStatus } from '@/types/shared';
import CouponCardTriple, { StyleType } from '../CouponCardTriple';
import './index.scss';
/**
 * 横向滑动优惠券组件
 * 使用max-scrollview实现横向滚动显示多个优惠券卡片
 * 支持背景图片作为组件背景
 */
const CouponHorizontal = memo(({ prizes, backgroundImage, backgroundWidth = 702, backgroundHeight = 356, scrollViewMarginTop = 0, onPrizePress, isShowClaimAll, claimOnClickConfig, onClaimAllPress, handleMvReport, handleClaimAllMv, titleColor, title = '' }) => {
    if (!prizes || prizes.length === 0) {
        return null;
    }
    const isCanDraw = prizes.every(prize => prize.prizeStatus === PrizeStatus.CAN_DRAW);
    let height = backgroundHeight;
    if (isShowClaimAll && isCanDraw) {
        height += 24;
    }
    const wrapStyle = {
        // marginTop:  backgroundImage ? '76rpx' : '0rpx',
        paddingBottom: isShowClaimAll && isCanDraw ? '24rpx' : '0rpx'
    };
    return <View className="coupon-horizontal-wrapper" style={{
            width: `${backgroundWidth}rpx`,
            height: `${height}rpx`,
            overflow: 'hidden'
        }}>
        <Image x-if={backgroundImage} source={{
            uri: backgroundImage || ''
        }} className="background-image" style={{
            width: `${backgroundWidth}rpx`,
            height: `${backgroundHeight}rpx`
        }} borderRadius={0}/>
      <View style={wrapStyle}>
        <View x-if={title} className="coupon-horizontal-title">
          <Text className="coupon-horizontal-title-text" style={{
            color: titleColor || '#111111'
        }}>{title}</Text>
        </View>
        
        <ScrollView className="coupon-horizontal-scroll" style={{
            marginTop: `${scrollViewMarginTop}rpx`
        }} horizontal showsHorizontalScrollIndicator={false} scrollEventThrottle={16}>
            <View className="scroll-content">
            {prizes.map((prize, index) => <Sensor key={`${prize.prizeBatchId}-${index}`} once onAppear={() => handleMvReport?.(prize)}>
                  <CouponCardTriple prize={prize} onPress={onPrizePress} styleType={StyleType.horizontal}/>
                </Sensor>)}
            </View>
        </ScrollView>
      </View>
      <Sensor x-if={isShowClaimAll && isCanDraw} once onAppear={() => handleClaimAllMv?.()} className="coupon-horizontal-claim-all" style={{
            width: `${backgroundWidth}rpx`
        }}>
          <Image source={{
            uri: claimOnClickConfig?.packageButtonBgImg || 'https://img.meituan.net/makerjiulv/8860a5fdb9d457b4c0ed6927076b509e3024.png'
        }} style={{
            width: `${backgroundWidth}rpx`,
            height: '155rpx'
        }} borderRadius={0} className="claim-all-bg"/>
          <View className="claim-all-button-wrapper">
              <Button className="claim-all-button" style={{
            backgroundColor: claimOnClickConfig?.buttonColor || '#FF2D19'
        }} onPress={onClaimAllPress}>
                  <Text className="claim-all-button-text" style={{
            color: claimOnClickConfig?.fontColor || '#FFFFFF'
        }}>
                      {claimOnClickConfig?.buttonText || '一键领取'}
                  </Text>
              </Button>
          </View>
      </Sensor>
    </View>;
});
CouponHorizontal.displayName = 'CouponHorizontal';
export default CouponHorizontal;
